import {
    candidacyLoader,
    CandidacySummary,
    ChangePassword,
    changePasswordLoader,
    JobClosedCandidacies,
    jobClosedCandidaciesLoader,
    jobSummaryLoader,
} from '@enrich/shared-lib';
import { createBrowserRouter, redirect } from 'react-router-dom';
import { App, loader as appLoader } from '../App';
import { ErrorMessages } from '../constants';
import { Candidates, loader as candidatesLoader } from '../pages/Candidates';
import {
    ClientContactProfile,
    contactLoader,
} from '../pages/ClientContactProfile';
import { ClientJobSummary } from '../pages/ClientJobSummary';
import { ClosedJobs } from '../pages/ClosedJobs';
import { Dashboard } from '../pages/Dashboard';
import { ErrorPage } from '../pages/ErrorPage';
import { InfoSessions } from '../pages/InfoSessions';
import { Jobs } from '../pages/Jobs';
import { NewJobForm } from '../pages/Jobs/NewJobForm';
import { Login, loader as loginLoader } from '../pages/Login';
import { ForgotPassword, ResetPassword } from '@enrich/shared-lib';
import BannerLogo from '../enrichLogo.png';
import MarketingImage from '../photo_marketing_presentation.jpg';

export const router = createBrowserRouter([
    {
        path: '/',
        element: <ErrorPage message={ErrorMessages.noCompanySlug} />,
    },
    {
        path: '/:companySlug/login',
        element: <Login />,
        loader: loginLoader,
    },
    {
        path: '/:companySlug/forgot-password',
        element: (
            <ForgotPassword
                slugParam="companySlug"
                loginPathTemplate="/:slug/login"
                resetPathTemplate="/:slug/reset-password"
                marketingImage={MarketingImage}
                bannerLogo={BannerLogo}
            />
        ),
    },
    {
        path: '/:companySlug/reset-password',
        element: (
            <ResetPassword
                slugParam="companySlug"
                dashboardPathTemplate="/:slug/dashboard"
                marketingImage={MarketingImage}
                bannerLogo={BannerLogo}
            />
        ),
    },
    {
        path: '/:companySlug/change-password',
        element: (
            <ChangePassword
                slugParam="companySlug"
                portalLabel="Company Portal"
            />
        ),
        loader: (routeParams) =>
            changePasswordLoader({
                ...routeParams,
                slugParam: 'companySlug',
                entityKey: 'company',
            }),
    },
    {
        path: '/:companySlug',
        element: <App />,
        loader: appLoader,
        errorElement: <ErrorPage />,
        children: [
            {
                index: true,
                loader: ({ params }) =>
                    redirect(`/${params.companySlug}/dashboard`),
            },
            {
                path: 'dashboard',
                element: <Dashboard />,
            },
            {
                path: 'sessions',
                element: <InfoSessions />,
            },
            {
                path: 'jobs',
                element: <Jobs />,
            },
            {
                path: 'jobs/create',
                element: <NewJobForm />,
            },
            {
                path: 'jobs/closed',
                element: <ClosedJobs />,
            },
            {
                path: 'jobs/:jobId',
                element: <ClientJobSummary />,
                loader: jobSummaryLoader,
            },
            {
                path: 'jobs/:jobId/closed',
                element: <JobClosedCandidacies showAdminActions={false} />,
                loader: jobClosedCandidaciesLoader,
            },
            {
                path: 'jobs/:jobId/candidacies/:candidacyId',
                element: <CandidacySummary />,
                loader: candidacyLoader,
            },
            {
                path: 'candidates',
                element: <Candidates />,
                loader: candidatesLoader,
            },
            {
                path: 'candidates/:contactId',
                element: <ClientContactProfile />,
                loader: contactLoader,
            },
        ],
    },
]);
